var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellerDashboardCreatestudyDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 153,
    viewBox: "0 0 408 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_9149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_41_9149)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 175,
    fill: "url(#paint0_linear_41_9149)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    filter: "url(#filter0_d_41_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 -16C66 -19.3137 68.6863 -22 72 -22H418C421.314 -22 424 -19.3137 424 -16V23C424 26.3137 421.314 29 418 29H72C68.6863 29 66 26.3137 66 23V-16Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: -16,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: -0.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 11.5,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_41_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.016 -2.87242C375.635 -2.87255 375.247 -2.63575 375.016 -2.16441L373.6 0.750718L370.373 1.20879C369.335 1.35319 368.999 2.37146 369.748 3.10346L372.08 5.37346L371.539 8.55945C371.361 9.59079 372.216 10.2141 373.142 9.72545C373.5 9.53612 375.34 8.58279 376.016 8.22612L378.889 9.72545C379.817 10.2141 380.675 9.59145 380.493 8.55945L379.93 5.37346L382.263 3.10346C383.016 2.37412 382.697 1.35612 381.659 1.20879L378.41 0.750718L377.015 -2.16441C376.785 -2.63595 376.396 -2.87222 376.016 -2.87242Z",
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.864 9.14C397.267 9.14 396.711 9.028 396.198 8.804C395.694 8.57067 395.283 8.23933 394.966 7.81C394.658 7.38067 394.485 6.87667 394.448 6.298H396.086C396.179 6.68067 396.385 6.984 396.702 7.208C397.019 7.432 397.407 7.544 397.864 7.544C398.191 7.544 398.489 7.46933 398.76 7.32C399.031 7.16133 399.241 6.95133 399.39 6.69C399.549 6.41933 399.628 6.12533 399.628 5.808C399.628 5.46267 399.549 5.15467 399.39 4.884C399.241 4.61333 399.031 4.40333 398.76 4.254C398.489 4.09533 398.191 4.016 397.864 4.016C397.547 4.016 397.248 4.072 396.968 4.184C396.688 4.28667 396.469 4.43133 396.31 4.618H394.882L395.33 -0.800001H400.678V0.74H396.8L396.562 3.134C396.73 2.98467 396.954 2.868 397.234 2.784C397.523 2.69067 397.808 2.644 398.088 2.644C398.704 2.644 399.255 2.77467 399.74 3.036C400.235 3.29733 400.617 3.67067 400.888 4.156C401.168 4.64133 401.308 5.20133 401.308 5.836C401.308 6.44267 401.154 6.998 400.846 7.502C400.547 8.006 400.132 8.40733 399.6 8.706C399.077 8.99533 398.499 9.14 397.864 9.14Z",
    fill: "#BEC6FF"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_d_41_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 41C66 37.6863 68.6863 35 72 35H418C421.314 35 424 37.6863 424 41V82C424 85.3137 421.314 88 418 88H72C68.6863 88 66 85.3137 66 82V41Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 42,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 45.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 57.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 69.5,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 55C313 50.5817 316.582 47 321 47H408V76H313V55Z",
    fill: "#F6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 54.8021C328.094 54.8021 327.308 55.2368 326.687 55.8855C325.784 55.8655 324.906 56.1041 324.27 56.7395C323.635 57.3748 323.396 58.2535 323.416 59.1561C322.767 59.7768 322.333 60.5628 322.333 61.4688C322.333 62.3748 322.767 63.1608 323.416 63.7815C323.396 64.6841 323.635 65.5628 324.27 66.1981C324.906 66.8335 325.784 67.0728 326.687 67.0521C327.308 67.7008 328.094 68.1355 329 68.1355C329.906 68.1355 330.692 67.7008 331.312 67.0521C332.215 67.0721 333.094 66.8335 333.729 66.1981C334.364 65.5628 334.603 64.6841 334.583 63.7815C335.232 63.1608 335.666 62.3748 335.666 61.4688C335.666 60.5628 335.232 59.7768 334.583 59.1561C334.603 58.2535 334.364 57.3748 333.729 56.7395C333.093 56.1041 332.215 55.8648 331.312 55.8855C330.692 55.2368 329.906 54.8021 329 54.8021ZM331 59.4688C331.17 59.4688 331.349 59.5261 331.479 59.6561C331.739 59.9168 331.739 60.3541 331.479 60.6148L328.812 63.2815C328.552 63.5415 328.114 63.5415 327.854 63.2815L326.52 61.9481C326.26 61.6875 326.26 61.2501 326.52 60.9895C326.781 60.7295 327.218 60.7295 327.479 60.9895L328.333 61.8435L330.52 59.6561C330.651 59.5261 330.829 59.4688 331 59.4688Z",
    fill: "#4051EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.89 57.2L345.522 64.382L348.154 57.2H349.876L346.194 67H344.836L341.14 57.2H342.89ZM357.066 57.2V58.768H352.936V61.078H356.632V62.646H352.936V65.432H357.066V67H351.298V57.2H357.066ZM358.974 57.2H362.642C363.184 57.2 363.683 57.3307 364.14 57.592C364.607 57.844 364.976 58.194 365.246 58.642C365.517 59.09 365.652 59.58 365.652 60.112C365.652 60.784 365.484 61.3673 365.148 61.862C364.822 62.3473 364.374 62.688 363.804 62.884L366.464 67H364.476L362.054 63.066H360.612V67H358.974V57.2ZM362.6 61.498C363.002 61.498 363.333 61.3673 363.594 61.106C363.865 60.8447 364 60.5133 364 60.112C364 59.7293 363.865 59.412 363.594 59.16C363.333 58.908 363.002 58.782 362.6 58.782H360.612V61.498H362.6ZM369.492 57.2V67H367.854V57.2H369.492ZM377.552 57.2V58.768H373.422V61.302H377.118V62.87H373.422V67H371.784V57.2H377.552ZM380.839 57.2V67H379.201V57.2H380.839ZM388.899 57.2V58.768H384.769V61.078H388.465V62.646H384.769V65.432H388.899V67H383.131V57.2H388.899ZM394.028 57.2C394.943 57.2 395.773 57.41 396.52 57.83C397.267 58.25 397.855 58.8333 398.284 59.58C398.713 60.3173 398.928 61.1433 398.928 62.058C398.928 62.982 398.713 63.822 398.284 64.578C397.855 65.334 397.267 65.9267 396.52 66.356C395.773 66.7853 394.943 67 394.028 67H390.808V57.2H394.028ZM394.14 65.432C394.728 65.432 395.255 65.2873 395.722 64.998C396.198 64.6993 396.571 64.2933 396.842 63.78C397.113 63.2667 397.248 62.6927 397.248 62.058C397.248 61.4233 397.113 60.8587 396.842 60.364C396.581 59.86 396.212 59.468 395.736 59.188C395.26 58.908 394.728 58.768 394.14 58.768H392.446V65.432H394.14Z",
    fill: "#4051EC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.33,
    filter: "url(#filter2_d_41_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 100C66 96.6863 68.6863 94 72 94H418C421.314 94 424 96.6863 424 100V139C424 142.314 421.314 145 418 145H72C68.6863 145 66 142.314 66 139V100Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 100,
    width: 39,
    height: 39,
    rx: 4,
    fill: "#F4F1FE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 103.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 115.5,
    width: 135,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 127.5,
    width: 54,
    height: 8,
    rx: 3,
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_41_9149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.016 113.128C374.635 113.127 374.247 113.364 374.016 113.836L372.6 116.751L369.373 117.209C368.335 117.353 367.999 118.371 368.748 119.103L371.08 121.373L370.539 124.559C370.361 125.591 371.216 126.214 372.142 125.725C372.5 125.536 374.34 124.583 375.016 124.226L377.889 125.725C378.817 126.214 379.675 125.591 379.493 124.559L378.93 121.373L381.263 119.103C382.016 118.374 381.697 117.356 380.659 117.209L377.41 116.751L376.015 113.836C375.785 113.364 375.396 113.128 375.016 113.128Z",
    fill: "#BEC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.322 121.78L396.808 115.2H398.67L395.366 121.416H400.994V122.9H393.322V121.78ZM398.194 118.658H399.832V125H398.194V118.658Z",
    fill: "#BEC6FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_9149",
    x: 57,
    y: -31,
    width: 388,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_9149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_9149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_41_9149",
    x: 37,
    y: 15,
    width: 418,
    height: 113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_9149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_9149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_41_9149",
    x: 57,
    y: 85,
    width: 388,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_9149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_9149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_9149",
    x1: 408,
    y1: -0.00000102962,
    x2: 171.678,
    y2: 305.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FFEAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_9149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 152.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_41_9149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 175,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_41_9149"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 368,
    y: -7,
    width: 34,
    height: 21,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_41_9149"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367,
    y: 109,
    width: 35,
    height: 21,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellerDashboardCreatestudyDisabled);
export default __webpack_public_path__ + "static/media/seller_dashboard_createstudy_disabled.b301e3042eb3ea1799bc234986ca2772.svg";
export { ForwardRef as ReactComponent };